<script>
// import RexModal from '@/rex-components/rex-modal.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
// import RexButton from '@/rex-components/rex-button.vue';
import { mapMutations } from 'vuex';

export default {
  components: { RexModalV3 },
  methods: {
    ...mapMutations('globalState/app', ['setIsFormOpened']),
  },
  unmounted() {
    this.setIsFormOpened(false);
  },
};
</script>

<template>
  <div>
    <RexModalV3
      :show="true"
      @onClose="() => $emit('onClose')"
      @onSubmit="() => $emit('onSubmit')"
      :submitText="$t('log.delete')"
      :title="$t('log.deleteGrokPattern')"
    >
      <template #body>
        <div>
          {{ $t('log.deleteGrokPatternInfoMessage') }}
        </div>
      </template>

      <!-- <template v-slot:footer>
        <div class="delete-grok-footer">
          <div>
            <RexButton
              variant="secondary"
              @onClick="$emit('onClose')"
              id="delete-grok-btn-cancel"
            >
              {{ $t('log.cancel') }}
            </RexButton>
          </div>
          <div class="grok-delete-btn">
            <RexButton
              variant="primary"
              @onClick="$emit('onSubmit')"
              id="delete-grok-btn-submit"
              style="width: 6rem"
            >
              {{ $t('log.delete') }}
            </RexButton>
          </div>
        </div>
      </template> -->
    </RexModalV3>
  </div>
</template>

<style lang="scss" scoped>
.delete-grok-footer {
  @include flex-center-justify(flex-end);
}
.grok-delete-btn {
  margin-left: 1rem;
}
</style>
